import i18n from '../i18n/i18n';

/**
 * Locale-aware labels for SIT enums. Internal numeric codes stay stable; the
 * displayed label comes from the `sit` i18n namespace. For Compass (pt-BR) the
 * stage gates render as N4→N0; other tenants keep the English DOI labels.
 */
export const stageGateLabel = (doiStage: number): string =>
    i18n.t(`stageGate.${doiStage}`, {ns: 'sit', defaultValue: String(doiStage)});

export const complexityTierLabel = (v?: number | null): string =>
    v ? i18n.t(`complexityTier.${v}`, {ns: 'sit', defaultValue: ''}) : '';

export const workstreamLabel = (v?: number | null): string =>
    v ? i18n.t(`workstream.${v}`, {ns: 'sit', defaultValue: ''}) : '';

export const executionStatusLabel = (v?: number | null): string =>
    v ? i18n.t(`executionStatus.${v}`, {ns: 'sit', defaultValue: ''}) : '';

export const baselineSourceLabel = (v?: number | null): string =>
    v ? i18n.t(`baselineSource.${v}`, {ns: 'sit', defaultValue: ''}) : '';

export const cancellationReasonLabel = (v?: number | null): string =>
    v ? i18n.t(`cancellationReason.${v}`, {ns: 'sit', defaultValue: ''}) : '';

export const sitFieldLabel = (key: string): string =>
    i18n.t(`field.${key}`, {ns: 'sit', defaultValue: key});

export const sitColumnLabel = (key: string): string =>
    i18n.t(`column.${key}`, {ns: 'sit', defaultValue: key});
